((Drupal) => {
  "use strict";

  Drupal.behaviors.mobileNavbarBurgerMenu = {
    attach: () => {
      const navbarCollapse = document.getElementById('main-navbar');
      const body = document.body;
      if (!navbarCollapse) return;

      navbarCollapse.addEventListener('show.bs.collapse', () => {
        body.classList.add('no-scroll');
      });

      navbarCollapse.addEventListener('hide.bs.collapse', () => {
        body.classList.remove('no-scroll');
      });
    },
  };

})(Drupal);
